import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductFinder = () => {
  const [material, setMaterial] = useState('');
  const [crossSection, setCrossSection] = useState('');
  
  const handleFind = () => {
    let recommendation = 'En çok tercih edilen: Bimetal M42';
    let path = '/urunler/bimetal';
    
    if (material === 'A' && crossSection === 'X') {
      recommendation = 'MARATHON® M42 veya PRIMAR® M42 (Bimetal)';
      path = '/urunler/bimetal';
    } else if (material === 'B' && crossSection === 'Y') {
      recommendation = 'PROFLEX® PREMIUM M42 veya FUTURA® SN';
      path = '/urunler/karbur';
    } else if (material === 'C') {
      recommendation = 'FUTURA® 718 veya PRIMALLOY™';
      path = '/urunler/karbur';
    } else if (material === 'D') {
      recommendation = 'DURATEC™ SFB (Karbon Serisi)';
      path = '/urunler/karbon';
    } else if (material === 'E') {
      recommendation = 'DIAGRIT® K veya CUBOGRIT®';
      path = '/urunler/elmas-cbn';
    } else if (material && crossSection) {
      recommendation = 'Bimetal veya Karbür Serileri';
      path = '/urunler/bimetal';
    }

    return { recommendation, path };
  };

  const result = handleFind();

  return (
    <section id="product-finder" className="product-finder-section">
      <div className="container">
        <div className="finder-box reveal">
          <div className="finder-header">
            <h2>Size En Uygun <span className="highlight">Testereyi Bulun</span></h2>
            <p>Malzemenizi ve kesim tipini seçin, size en uygun testereyi anında önerelim.</p>
          </div>
          
          <div className="finder-form">
            <div className="form-group">
              <label>Hangi malzemeyi keseceksiniz?</label>
              <select value={material} onChange={(e) => setMaterial(e.target.value)}>
                <option value="">-- Seçiniz --</option>
                <option value="A">Genel Yapı Çeliği / Karbon Çeliği</option>
                <option value="B">Paslanmaz Çelik / Takım Çeliği</option>
                <option value="C">Süper Alaşım (Inconel, Titanyum)</option>
                <option value="D">Alüminyum / Ahşap / Plastik</option>
                <option value="E">Cam / Seramik / Sertleştirilmiş Çelik (55+ HRC)</option>
              </select>
            </div>
            
            <div className="form-group">
              <label>Kesit Tipi Nedir?</label>
              <select value={crossSection} onChange={(e) => setCrossSection(e.target.value)}>
                <option value="">-- Seçiniz --</option>
                <option value="X">Dolu Malzeme (Kütük)</option>
                <option value="Y">İçi Boş Profil / Boru</option>
                <option value="Z">Karma / Çoklu Kesit</option>
              </select>
            </div>
          </div>

          <div className="finder-result slide-down" style={{ transition: 'all 0.3s', backgroundColor: material || crossSection ? 'rgba(220, 38, 38, 0.15)' : 'rgba(255,255,255,0.05)', borderColor: material || crossSection ? 'rgba(220, 38, 38, 0.4)' : 'rgba(255,255,255,0.1)' }}>
            <h3 style={{ color: material || crossSection ? '#fca5a5' : '#94a3b8' }}>
              {material || crossSection ? 'Önerilen Kesici Takım:' : 'Tavsiye Edilen Başlangıç Modeli:'}
            </h3>
            <p className="result-text">{result.recommendation}</p>
            <Link to={result.path} className="btn-primary" style={{ marginTop: '15px', display: 'inline-block' }}>Ürünü İncele</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductFinder;
